export default {
  palette: {
    primary: {
      light: "#9f3e72",
      main: "#880e4f",
      dark: "#5f0937",
      constrastText: "#fff",
    },
    secondary: {
      light: "#ffcf33",
      main: "#ffc400",
      dark: "#b28900",
      constrastText: "#000",
    },
  },
  typography: {
    useNextVariants: true,
  },
};
